import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../api/services/user.service';
import { User } from '../../../api/models/user-model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteModalComponent } from '../../delete-modal/delete-modal.component';
import { PreferencesService } from '../../../api/services/preferences.service';
import { of } from 'rxjs/observable/of';
import { FileUploadService } from '../../../api/services/file-upload.service';
import { flatMap } from 'rxjs/operators';
import { AuthService } from '../../../api/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit {

  constructor(private userService: UserService,
    private preferencesService: PreferencesService,
    private fileUploadService: FileUploadService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private authService: AuthService
  ) { }

  users = [];
  items: User[] = [];
  itemsFiltered: User[] = [];
  itemsToShow: User[] = [];
  page = 1;
  pageSize = 50;
  loading = false;
  edit = false;
  userSelected: User;
  visibleContext = false;
  infoMsg = ['No records found!'];

  canEdit = false;
  canDelete = false;

  loadPage(page) {
    const from = (page - 1) * this.pageSize;
    const to = from + this.pageSize;
    this.itemsToShow = this.itemsFiltered.slice(from, to);
  }

  delete(item) {
    const modalRef = this.modalService.open(DeleteModalComponent, {
      backdrop : 'static',
      keyboard : false
    });
    modalRef.componentInstance.bodyMsg = `Are you sure you want to delete the User <strong>${item['First Name']} ${item['Last Name']}</strong> ?`;
    modalRef.componentInstance.fn = () => {
      this.userService.removeUser(item['User ID']).subscribe(() => {
        modalRef.close();
        this.onUpdateSuccess();
        this.refresh();
      });
    };
  }

  private onUpdateSuccess() {
    this.toastr.success('User deleted!!!', 'Succcess!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  refresh() {
    this.loading = true;
    this.userService.getUsers()
      // .map(users => { if (users) {
      //    return (users.sort((a, b) => a['User ID'] > b['User ID'] ? 1 : -1));
      // }} )
      .subscribe((users) => {
        this.loading = false;
        if (!users) {
            return;
        }
        this.items = this.itemsFiltered = users;
        this.loadPage(this.page);
      });
  }

  getProfileImage(userId: string) {
    return this.preferencesService.getPreferences('CUSTOMER', userId)
      .pipe(flatMap((prefs) => {
        const logoId = prefs['profile-logo'].Value;

        if (!logoId) {
          return of('/assets/images/avatar-profile-image.png');
        }

        return this.fileUploadService.get(logoId).map(({ url }) => url);
      }));
  }

  searchUser(value) {
    this.page = 1;
    if (value) {
      const lowerCaseValue = value.toLowerCase();

      this.itemsFiltered = this.items.filter(x => `${x['First Name']} ${x['Last Name']}`.toLowerCase().includes(lowerCaseValue) ||
         x['First Name'].toLowerCase().includes(lowerCaseValue) ||
        x['Last Name'].toLowerCase().includes(lowerCaseValue) ||
        x['Email Address'].toLowerCase().includes(lowerCaseValue)
      );
    } else {
      this.itemsFiltered = this.items;
    }
    this.loadPage(this.page);
  }

  editUser(user: User) {
    this.userSelected = user;
    this.edit = true;
  }

  createUser() {
    this.userSelected = new User();
    this.edit = true;
  }

  backToListing() {
    this.edit = false;
    this.refresh();
  }


  ngOnInit() {
    this.calculatePermissions(['USER_CREATE']);
    this.userService.findUserById(this.authService.getUserId())
      .switchMap(user => this.authService.getUserRolesInContext(`ORGANIZATION~${user['Organization ID']}`))
      .subscribe(roles => {
        this.canEdit = roles.includes('USER_UPDATE');
        this.canDelete = roles.includes('USER_DELETE');
      });

    this.refresh();
  }

  calculatePermissions(requiredRoles: string[], context?: string) {
    if (context === 'MARKET') {
      this.preferencesService.getPreferences('USER', this.authService.getUserId())
        .subscribe(prefs => {
          const currentMarket = prefs['current-market'].Value;
          this.authService.getUserRolesInContext(`${context}~${currentMarket}`).subscribe(roles => {
            this.visibleContext = requiredRoles.every(r => roles.includes(r));
          });
        });
    } else {
      this.userService.findUserById(this.authService.getUserId()).subscribe(user => {
        const con = `ORGANIZATION~${user['Organization ID']}`;
        this.authService.getUserRolesInContext(con).subscribe(roles => {
          this.visibleContext = requiredRoles.every(r => roles.includes(r));
        });
      });
    }
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/management/user-list/user-list.component.ts